/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../redux/store';
import { capitalizeFirstLetter, removeLastLetter } from 'serenova-js-utils/strings';

import { DetailHeader, ConfirmationWrapper, Toggle } from 'cx-ui-components';
import { ListField } from './Fields/ListField';
import { AddFilter } from './Fields/AddFilterField';
import { ProficiencyField } from './Fields/ProficiencyField';
import { AddSearchQuery } from './Fields/AddSearchQueryField';
import { SearchQueryLevel } from './Fields/EscalationQueryField';
import { FiltersAutoCompleteField } from './Fields/AutoCompleteField';
import { SortByEntityField } from "./Fields/SortByEntityField";
import { SortByListField } from "./Fields/SortByListField";

const FiltersHeadingWrapper = styled.div`
  display: flex;
  margin: 10px 0 10px 20px;
`;
const StyledDetailHeader = styled(DetailHeader)`
  flex-grow: 1;
  color: #656565 !important;
  margin: 0px !important;
`;
const RemoveFilterBtn = styled.span`
  display: inline-block;
  font-size: 14px;
  color: #3498db;
  cursor: pointer;
  :hover {
    color: #07487a;
  }
`;
const SortByProficiencyWrapper = styled.div`
  //margin-left: 35px;
`;
const SortByProficiencyToggle = styled(Toggle)`
  margin-left: 5px;
`;
const Label = styled.label`
  display: inline-block;
  flex-shrink: 0;
  font-size: 14px;
  width: 190px;
  margin-top: 5px;
  margin-left: 35px;
  padding-bottom: 15px;
`;

class FiltersComponent extends React.Component {
  constructor(props) {
    super(props);
    var val=props.basicQuery && props.basicQuery.toJS() && props.basicQuery.toJS()[0].map.some(m=>m[0].key=='sort')
    this.state = {
      sortByProficiency: val
    };
  }

  setSortByProficiency(value) {
    this.setState( {sortByProficiency: !value} );
  }

  render() {
    const { fields, basicQuery, change, dependentEntities, querylevelCountInSelectedVersion, matchmaker2Enabled } = this.props;
    return (
      <Fragment>
        {fields &&
          fields.getAll() &&
          fields
            .getAll()
            .toJS()
            .map((field, index) => {
              const secondsInQueue =
                field &&
                field.map &&
                field.map.find((list) => list && list[0] && list[0]['key'] === 'after-seconds-in-queue');

              const level =
                field && field.map && field.map.find((list) => list && list[0] && list[0]['key'] === 'query');
              const sortLevel =
                field && field.map && field.map.find((list) => list && list[0] && list[0]['key'] === 'sort');

              const filterItems = level && level[1] && level[1]['map'];
              const sortFilterItems = sortLevel && sortLevel[1] && sortLevel[1][0]['list'] && sortLevel[1][0]['list'][0]['map'];

              const options =
                filterItems &&
                filterItems
                  .map((filter) => filter && filter.find((f) => f.key) && filter.find((f) => f.key)['key'])
                  .map((key) => (key === 'user-id' ? 'users' : key));

              const addFilterOptions = ['Skills', 'Groups', 'Users']
                .filter((entity) => options && !options.includes(entity.toLowerCase()))
                .map((entity) => ({ value: entity.toLowerCase(), label: entity }));

              const showProficiency = (entity, allOrAny) => {
                const selectedValue =
                  basicQuery && basicQuery.getIn([index, 'selectedFilters', entity, allOrAny, 'val']);
                const selectedSkill = dependentEntities['skills'].find((skill) =>
                    skill.name?.replace(/\s+/g, ' ').trim() === selectedValue?.replace(/\s+/g, ' ').trim()
                );
                return selectedSkill && selectedSkill.hasProficiency;
              };

              const FiltersList =
                filterItems &&
                filterItems.map((filter, filterIndex) => {
                  const { key: entity } = filter && filter.find((f) => f.key);
                  const allList = filter && filter[1].find((lists) => lists.list[0].sym === 'every');
                  const anyList = filter && filter[1].find((lists) => lists.list[0].sym === 'some');
                  let sortList;
                  if (entity === 'skills') {
                    sortList = sortFilterItems && sortFilterItems.map((filter) => filter);
                  }

                  const availableFilters = {
                    skills: {},
                    groups: {},
                    'user-id': {},
                  };
                  let sortAvailableFilters;

                  const getListItems = (allOrAny) => {
                    const entityName = entity === 'user-id' ? 'users' : entity;
                    const listType = allOrAny === 'every' ? allList : anyList;
                    const everyOrSome = listType && listType.list[0].sym === 'every' ? 'All' : 'Any';

                    const listItems =
                      entityName === 'skills'
                        ? listType && listType.list[1]['map']
                        : listType && listType.list[1]['set'];

                    const selectedItems =
                      listItems && listItems.map((item) => (entity === 'skills' ? item[0].val : item.val));

                    //trimming blank spaces from entityItem name
                    if (!selectedItems) {
                      availableFilters[entity][everyOrSome] =
                        dependentEntities[entityName] &&
                        dependentEntities[entityName]
                          .filter(
                            (entityItem) => (entity === 'user-id' ? entityItem.firstName || entityItem.lastName : true)
                          )
                          .map(
                            (entityItem) =>
                              entity === 'user-id'
                                ? `${entityItem.firstName ? entityItem.firstName : ''} ${
                                    entityItem.lastName ? entityItem.lastName : ''
                                  }`
                                : entityItem.name.replace(/\s+/g, ' ').trim()
                          );
                    } else {
                      availableFilters[entity][everyOrSome] =
                        dependentEntities[entityName] &&
                        dependentEntities[entityName]
                          .filter((entityItem) => !selectedItems.includes(entityItem.id))
                          .filter(
                            (entityItem) => (entity === 'user-id' ? entityItem.firstName || entityItem.lastName : true)
                          )
                          .map(
                            (entityItem) =>
                              entity === 'user-id'
                                ? `${entityItem.firstName ? entityItem.firstName : ''} ${
                                    entityItem.lastName ? entityItem.lastName : ''
                                  }`
                                : entityItem.name.replace(/\s+/g, ' ').trim()
                          );
                    }

                    if (entity === 'skills') {
                      return (
                        listItems &&
                        listItems.reduce((acc, item) => {
                          const skillItem =
                            dependentEntities[entity] &&
                            dependentEntities[entity].find((skill) => skill.id === item[0].val);

                          skillItem &&
                            acc.push({
                              id: skillItem.id,
                              name: `${skillItem.name} (${item[1].list[0].sym} ${item[1].list[1]})`,
                            });
                          return acc;
                        }, [])
                      );
                    } else if (entity === 'groups') {
                      return (
                        selectedItems &&
                        selectedItems.map((itemId) => {
                          const groupsInfo =
                            dependentEntities[entity] && dependentEntities[entity].find((group) => group.id === itemId);
                          return groupsInfo && { id: groupsInfo.id, name: groupsInfo.name };
                        })
                      );
                    } else if (entity === 'user-id' && allOrAny === 'some') {
                      return (
                        selectedItems &&
                        selectedItems.map((itemId) => {
                          const userInfo =
                            dependentEntities['users'] && dependentEntities['users'].find((user) => user.id === itemId);
                          return userInfo && { id: userInfo.id, name: `${userInfo.firstName} ${userInfo.lastName}` };
                        })
                      );
                    }
                  };

                  const getSortListItems = () => {
                    const listItems = sortList && sortList.map((item) => item);
                    const selectedItems = listItems && listItems.map((item) => {
                      return item[0].val;
                    });

                    let lists = [...allListItems, ...anyListItems];
                    lists = lists.filter((arr, index, self) =>
                      index === self.findIndex((t) => (t.id === arr.id))
                    ).map((entityItem) => {
                      let endIndex;
                      if (entityItem.name.indexOf('(>') > 0) {
                        endIndex = entityItem.name.indexOf('(>');
                      } else if (entityItem.name.indexOf('(<') > 0) {
                        endIndex = entityItem.name.indexOf('(<');
                      } else if (entityItem.name.indexOf('(=') > 0) {
                        endIndex = entityItem.name.indexOf('(=');
                      }
                      return {
                        id: entityItem.id,
                        name: entityItem.name.substring(0, (endIndex - 1))
                      };
                    });

                    //trimming blank spaces from entityItem name
                    if (!selectedItems) {
                      sortAvailableFilters = lists.map(
                        (entityItem) => entityItem.name.replace(/\s+/g, ' ').trim()
                      );
                    } else {
                      sortAvailableFilters = lists
                        .filter((entityItem) => !selectedItems.includes(entityItem.id))
                        .map(
                          (entityItem) => entityItem.name.replace(/\s+/g, ' ').trim()
                        );
                    }

                    return (
                      listItems &&
                      listItems.reduce((acc, item) => {
                        const skillItem =
                          dependentEntities[entity] &&
                          dependentEntities[entity].find((skill) => skill.id === item[0].val);

                        let order;
                        if (item[1].key === 'asc') {
                          order = '↑';
                        } else if (item[1].key === 'des') {
                          order = '↓';
                        }

                        skillItem &&
                        acc.push({
                          id: skillItem.id,
                          name: `${order} ${skillItem.name}`,
                        });
                        return acc;
                      }, [])
                    );
                  };

                  const allListItems = getListItems('every');
                  const anyListItems = getListItems('some');
                  let sortListItems;
                  if (entity === 'skills') {
                    sortListItems = getSortListItems();
                  }

                  const entityName =
                    entity && capitalizeFirstLetter(removeLastLetter(entity === 'user-id' ? 'users' : entity));

                  return (
                    <div key={`${entity}-${index}-${filterIndex}`}>
                      <FiltersHeadingWrapper>
                        <StyledDetailHeader text={`${entityName} Filters`} />
                        {(allListItems && allListItems.length > 0) || (anyListItems && anyListItems.length > 0) ? (
                          <ConfirmationWrapper
                            actionBtnType="button"
                            mainText="This filter is not empty. Removing this filter will modify the query. Continue?"
                            confirmBtnCallback={() =>
                              store.dispatch({ type: 'REMOVE_QUEUE_QUERY_FILTER', index: index, entity: entity })
                            }>
                            <RemoveFilterBtn>(remove filter)</RemoveFilterBtn>
                          </ConfirmationWrapper>
                        ) : (
                          <RemoveFilterBtn
                            onClick={(e) => {
                              e.stopPropagation();
                              store.dispatch({ type: 'REMOVE_QUEUE_QUERY_FILTER', index: index, entity: entity });
                            }}>
                            (remove filter)
                          </RemoveFilterBtn>
                        )}
                      </FiltersHeadingWrapper>
                      {entity !== 'user-id' && (
                        <FiltersAutoCompleteField
                          index={index}
                          entity={entity}
                          allOrAny="All"
                          listItems={allListItems}
                          basicQuery={basicQuery}
                          suggestions={availableFilters[entity]['All']}
                        />
                      )}
                      {entity === 'skills' &&
                        showProficiency(entity, 'All') && (
                          <ProficiencyField entity={entity} allOrAny="All" index={index} change={change} />
                        )}
                      <ListField entity={entity} dataSet={allListItems} allOrAny="All" index={index} />
                      <FiltersAutoCompleteField
                        index={index}
                        entity={entity}
                        allOrAny="Any"
                        listItems={anyListItems}
                        basicQuery={basicQuery}
                        suggestions={availableFilters[entity]['Any']}
                      />
                      {entity === 'skills' &&
                        showProficiency(entity, 'Any') && (
                          <ProficiencyField entity={entity} allOrAny="Any" index={index} change={change} />
                        )}
                      <ListField entity={entity} dataSet={anyListItems} allOrAny="Any" index={index} />
                      {(entity === 'skills' && matchmaker2Enabled) &&
                        <SortByProficiencyWrapper>
                          <Label>Sort by Proficiency</Label>
                          <SortByProficiencyToggle
                            onChange={() => {
                              this.setSortByProficiency(this.state.sortByProficiency);
                            }}
                            value={this.state.sortByProficiency}
                            disabled={false}
                          />
                          {this.state.sortByProficiency &&
                            <>
                              <SortByEntityField
                                index={index}
                                entity={entity}
                                listItems={sortListItems}
                                basicQuery={basicQuery}
                                suggestions={sortAvailableFilters}
                              />
                              <SortByListField entity={entity} dataSet={sortListItems} index={index} />
                            </>
                          }
                        </SortByProficiencyWrapper>
                      }
                    </div>
                  );
                });

              return (
                <div key={index}>
                  {secondsInQueue[0].key === 'after-seconds-in-queue' &&
                    index === 0 && (
                      <Fragment>
                        <AddFilter
                          index={index}
                          options={addFilterOptions}
                          disabled={addFilterOptions.length === 0}
                          basicQuery={basicQuery}
                        />
                        {FiltersList}
                      </Fragment>
                    )}
                  {(querylevelCountInSelectedVersion === 1 || index === 1) && (
                    <StyledDetailHeader text="Escalation Query" />
                  )}
                  {secondsInQueue[0].key === 'after-seconds-in-queue' &&
                    index !== 0 && (
                      <Fragment>
                        <SearchQueryLevel
                          index={index}
                          basicQuery={basicQuery}
                          fields={fields}
                          level={filterItems}
                          addFilterOptions={addFilterOptions}
                        />
                        {FiltersList}
                      </Fragment>
                    )}
                </div>
              );
            })}
        {<AddSearchQuery index={querylevelCountInSelectedVersion} />}
      </Fragment>
    );
  }
}

FiltersComponent.propTypes = {
  change: PropTypes.func,
  fields: PropTypes.object,
  basicQuery: PropTypes.object,
  dependentEntities: PropTypes.object,
  querylevelCountInSelectedVersion: PropTypes.number,
  matchmaker2Enabled: PropTypes.bool,
};

export default FiltersComponent;
